import { Link, useSearchParams } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

const PaymentCancelledPage = () => {
  const [params] = useSearchParams();
  const orderRef = params.get('ordernumber') || params.get('order_ref') || params.get('orderNumber') || '';
  return (
    <div className="container-pd py-16 max-w-lg" data-testid="payment-cancelled-page">
      <div className="font-mono text-[10px] text-[color:var(--pd-gold)] uppercase tracking-[0.2em]">Payment</div>
      <div className="mt-6 rounded-2xl border border-[color:var(--pd-gold)]/40 bg-surface p-6">
        <div className="flex items-start gap-3">
          <AlertCircle size={26} className="text-[color:var(--pd-gold)] shrink-0" />
          <div>
            <div className="font-display text-3xl leading-tight">Checkout cancelled.</div>
            <p className="text-sm text-muted-sage mt-2">Your card wasn&rsquo;t charged. No tickets have been issued.</p>
            {orderRef ? <p className="text-[11px] text-muted-sage mt-3 font-mono">Ref: {orderRef}</p> : null}
          </div>
        </div>
        <div className="mt-5 flex flex-wrap gap-2">
          <Link to="/competitions" className="bg-[color:var(--pd-accent-yellow)] text-[#14251c] px-4 py-2.5 rounded-xl text-sm font-medium">Back to competitions</Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelledPage;
